const enterprise_subscription = {
    page_title: 'การสมัครสมาชิก',
    title: 'จัดการการสมัครสมาชิกของคุณ',
    subtitle: 'นี่คือที่สำหรับจัดการการสมัครสมาชิกแบบหลายผู้เช่าและประวัติการเรียกเก็บเงินของคุณ',
    tab: {
        subscription: 'การสมัครสมาชิก',
        billing_history: 'ประวัติการเรียกเก็บเงิน',
    },
    subscription: {
        title: 'การสมัครสมาชิก',
        description: 'ติดตามการใช้งานของคุณได้อย่างง่ายดาย ดูใบเรียกเก็บเงินถัดไปของคุณ และตรวจสอบสัญญาเดิมของคุณ',
        enterprise_plan_title: 'แผนองค์กร',
        enterprise_plan_description: 'นี่คือการสมัครสมาชิกแผนองค์กรของคุณ และโควตานี้ถูกแชร์ข้ามผู้เช่า การใช้งานอาจมีความล่าช้าเล็กน้อยในการอัปเดต',
        add_on_title: 'จ่ายตามการใช้งานเสริม',
        add_on_description: 'เหล่านี้คือการใช้งานเสริมแบบจ่ายตามการใช้งานตามสัญญาของคุณหรืออัตรามาตรฐานแบบจ่ายตามการใช้งานของ Logto จะถูกเรียกเก็บเงินตามการใช้งานจริงของคุณ',
        included: 'ถูกรวมไว้',
        over_quota: 'เกินโควตา',
        basic_plan_column_title: {
            product: 'ผลิตภัณฑ์',
            usage: 'การใช้งาน',
            quota: 'โควตา',
        },
        add_on_column_title: {
            product: 'ผลิตภัณฑ์',
            unit_price: 'ราคาต่อหน่วย',
            quantity: 'ปริมาณ',
            total_price: 'ทั้งหมด',
        },
        add_on_sku_price: '${{price}}/เดือน',
        private_region_title: 'อินสแตนซ์คลาวด์ส่วนตัว ({{regionName}})',
        shared_cross_tenants: 'ข้ามผู้เช่า',
    },
    user_subscriptions: {
        description: 'ดูการสมัครสมาชิกส่วนบุคคลและสิทธิ์ Enterprise ตามสัญญา โดยไม่ขึ้นกับเทนเนนต์ที่เลือก',
        personal_title: 'การสมัครสมาชิกส่วนบุคคล',
        personal_description: 'การสมัครสมาชิกที่ใช้งานอยู่ซึ่งเรียกเก็บเงินจากบัญชีของคุณ รายการในอดีตยังคงอยู่ในประวัติการเรียกเก็บเงิน',
        price: 'ราคา',
        next_charge: 'การเรียกเก็บเงินครั้งถัดไป',
        ends_on: 'สิ้นสุดวันที่ {{date}}',
        overdue_note: 'การชำระเงินเกินกำหนด หากยังไม่ชำระ การสมัครสมาชิกอาจถูกหยุดชั่วคราวและฟีเจอร์แบบชำระเงินอาจถูกนำออก',
        other_product: 'การสมัครสมาชิกอื่น',
        enterprise_invoices_description: 'ใบแจ้งหนี้ของสัญญา Enterprise ของคุณ เลือกใบแจ้งหนี้เพื่อดูและดาวน์โหลดใบแจ้งหนี้หรือใบเสร็จ',
        personal_invoices_description: 'ใบแจ้งหนี้ของการสมัครสมาชิกที่เรียกเก็บกับบัญชีของคุณ รวมถึงการสมัครสมาชิกที่ผ่านมา เลือกใบแจ้งหนี้เพื่อดูและดาวน์โหลดใบแจ้งหนี้หรือใบเสร็จ',
        credit_note: 'เครดิตจากการนำออกหรือการคิดตามสัดส่วนจะหักจากใบแจ้งหนี้ถัดไป และอาจไม่ได้คืนเข้าวิธีการชำระเงินของคุณทันที',
        invoice_link_unavailable: 'หน้าใบแจ้งหนี้นี้ไม่พร้อมใช้งาน โปรดติดต่อเราหากต้องการสำเนา',
        status: {
            active: 'ใช้งานอยู่',
            trialing: 'ทดลองใช้',
            past_due: 'เกินกำหนด',
            unpaid: 'ยังไม่ชำระ',
            canceled: 'ยกเลิกแล้ว',
            incomplete: 'ไม่สมบูรณ์',
            incomplete_expired: 'หมดอายุ',
            paused: 'หยุดชั่วคราว',
        },
    },
};
export default Object.freeze(enterprise_subscription);
